export const PLAYER_TYPES = {
  PLAYER: 'player',
  RAID_ENEMY: 'raid_enemy',
  PLANET_RAIDER: 'planet_raider',
};
